import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Oman Pakistan Embassy Application',
        projectDesc: 'This application is playing a vital role in order to handle all admin level activities like notification and news update and setting up pending status .',
        tags: ['React', 'Firestore' , 'Cloud Functions' ,'CSS', 'Javascript'],
        code: '',
        demo: 'https://pakistan-embassy-muscat-6280f.web.app/login',
        image: "https://raw.githubusercontent.com/MuhammadHamza12/portfolio/master/src/assets/project_1.png"
    },
    {
        id: 2,
        projectName: 'School Smart',
        projectDesc: 'This is complete school ERP system, including all modules Finance , LMS , CMS , TimeTable and Attendence and much more as well',
        tags: ['React','Nodejs','Javascript','MySQL'],
        code: '',
        demo: 'https://dak.schoolsmart.org.uk/',
        image: "https://raw.githubusercontent.com/MuhammadHamza12/portfolio/master/src/assets/project_2.png"
    },
    {
        id: 21,
        projectName: 'School Smart',
        projectDesc: 'This is complete school ERP system, including all modules Finance , LMS , CMS , TimeTable and Attendence and much more as well',
        tags: ['React','Nodejs','Javascript','MySQL'],
        code: '',
        demo: 'https://dak.schoolsmart.org.uk/',
        image: "https://raw.githubusercontent.com/MuhammadHamza12/portfolio/master/src/assets/coinsiren.png"
    },
    {
        id: 3,
        projectName: 'Daily Diary',
        projectDesc: 'This project is for noting down daily tasks, where user can create, update and delete their routine activities just like daily to do',
        tags: ['React Native', 'Async Storage','Native Base', 'React Navigation'],
        code: 'https://github.com/MuhammadHamza12/react-native-diary-app',
        demo: 'https://youtu.be/Vrs6jFw7KQ8',
        image: "https://raw.githubusercontent.com/MuhammadHamza12/portfolio/master/src/assets/daily_dairy.jpeg"
    },
    {
        id: 4,
        projectName: 'Oman Pakistan Embassy Application ( Mobile Version )',
        projectDesc: 'This is the clone of reliancedigital.in. Features I worked on the Product Catalogue pages and also on some minor parts on other pages as well',
        tags: ['React Native', 'Firebase','React Navigation','Firebase Cloud Functions', 'Push notification'],
        code: 'https://github.com/sreerag-rajan/Reliance-Digital-Clone-U4-',
        demo: 'https://reliance-digital-clone.herokuapp.com/',
        image: "https://raw.githubusercontent.com/MuhammadHamza12/portfolio/master/src/assets/linkit.jpeg"
    },
    {
        id: 5,
        projectName: 'Beacon',
        projectDesc: 'This project is the clone of Reliance Digital built as a part of a project week. It simulates the functionality of an e-commerce website from landing page to checkout. My contribution was the product catalog page arriving from the navbar, as well as leading the team.',
        tags: ['React Native', 'UI Design', 'React Navigation'],
        code: 'https://github.com/iamrituyadav/Reliance_digital',
        demo: 'https://reliance-digital-clone.herokuapp.com/',
        image: "https://raw.githubusercontent.com/MuhammadHamza12/portfolio/master/src/assets/beacon.jpeg"
    },
    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/